// redux/recentlyVisitedSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [],
};

const recentlyVisitedSlice = createSlice({
  name: 'recentlyVisited',
  initialState,
  reducers: {
    addVisitedItem: (state, action) => {
      const { title, path } = action.payload;
      const existingIndex = state.items.findIndex(item => item.path === path);
      
      if (existingIndex >= 0) {
        // Remove existing item to re-add it at the beginning
        state.items.splice(existingIndex, 1);
      }
      
      // Add new item at the beginning
      state.items.unshift({
        title,
        path,
        timestamp: new Date().toISOString()
      });
      
      // Keep only last 10 items
      if (state.items.length > 10) {
        state.items = state.items.slice(0, 10);
      }
    },
    clearRecentItems: (state) => {
      state.items = [];
    },
    removeRecentItem: (state, action) => {
      const path = action.payload;
      state.items = state.items.filter(item => item.path !== path);
    }
  },
});

export const { addVisitedItem, clearRecentItems, removeRecentItem } = recentlyVisitedSlice.actions;

export const selectRecentItems = (state) => state.recentlyVisited.items;

export default recentlyVisitedSlice.reducer;